import React, { useState } from 'react';
import '../styles/UserRegistration.css';
import { Footer } from "./Footer";
import { api } from '../axios/AxiosInstances';

const UserRegistration = () => {
  const [data, setData] = useState({
    username: '',
    password: '',
    confirmpassword: '',
    userType: '',
    workshopname: '',
    country: '',
    site: ''
  });

  const [error, setError] = useState({
    usernameNotValid: false,
    usernameNotValidText: '',
    passwordNotValid: false,
    passwordNotValidText: '',
    confirmpasswordNotValid: false,
    confirmpasswordNotValidText: '',
    usertypeNotValid: false,
    usertypeNotValidText: '',
    workshopnameNotValid: false,
    workshopnameNotValidText: '',
    countryNotValid: false,
    countryNotValidText: '',
    siteNotValid: false,
    siteNotValidText: ''
  });

  const [showRegisterStatus, setShowRegisterStatus] = useState(false);
  const [registerStatus, setRegisterStatus] = useState('');
  const [registerStatusMessage, setRegisterStatusMessage] = useState('');
  const [hide, setHide] = useState(true);
  const [hide1, setHide1] = useState(true);
  const [showInfoBox, setShowInfoBox] = useState(false);
  const [multiSites, setMultiSites] = useState([]);
  const [featureSelection, setFeatureSelection] = useState([]);

  const userTypes = ['TPV Leader', 'TPV Technician', 'ASC Leader', 'ASC Technician', 'Manager'];
  const workshopNames = ['Gorzow'];
  const countries = ['Country1', 'Country2'];
  const sites = [{ site_name: 'ASC ABC', userid: 'ASC ABC' }];
  const features = ['Feature1', 'Feature2'];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const generatePass = () => {
    const password = generatePasswordRandom(9);
    setData(prevData => ({
      ...prevData,
      password: password,
      confirmpassword: password
    }));
  };

  const generatePasswordRandom = (length) => {
    const numberChars = '0123456789';
    const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
    const specialChars = '!@#$%^&*+.?={}|_-"';
    const allChars = numberChars + upperChars + lowerChars + specialChars;

    let randPasswordArray = Array(length);
    randPasswordArray[0] = numberChars;
    randPasswordArray[1] = upperChars;
    randPasswordArray[2] = lowerChars;
    randPasswordArray[3] = specialChars;
    randPasswordArray.fill(allChars, 4);

    const rawPassword = randPasswordArray.map(x => x[Math.floor(Math.random() * x.length)]);
    return shuffleArray(rawPassword).join('');
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const handleRegister = async () => {
    let hasError = false;
    const newError = {};

    if (!data.username) {
      newError.usernameNotValid = true;
      newError.usernameNotValidText = 'Username is required';
      hasError = true;
    }

    if (!data.password) {
      newError.passwordNotValid = true;
      newError.passwordNotValidText = 'Password is required';
      hasError = true;
    }

    if (!data.confirmpassword) {
      newError.confirmpasswordNotValid = true;
      newError.confirmpasswordNotValidText = 'Confirm Password is required';
      hasError = true;
    }

    if (data.password !== data.confirmpassword) {
      newError.confirmpasswordNotValid = true;
      newError.confirmpasswordNotValidText = 'Passwords do not match';
      hasError = true;
    }

    if (!data.userType) {
      newError.usertypeNotValid = true;
      newError.usertypeNotValidText = 'User Type is required';
      hasError = true;
    }

    if (!data.workshopname) {
      newError.workshopnameNotValid = true;
      newError.workshopnameNotValidText = 'Workshop Name is required';
      hasError = true;
    }

    if (hasError) {
      setError(newError);
      return;
    }

    try {
      const response = await api.post('/registeruser', data);
      if (response.data.status === "success") {
        setShowRegisterStatus(true);
        setRegisterStatus('success');
        setRegisterStatusMessage('User registered successfully');
      } else {
        setShowRegisterStatus(true);
        setRegisterStatus('error');
        setRegisterStatusMessage('Failed to register user');
      }
    } catch (error) {
      setShowRegisterStatus(true);
      setRegisterStatus('error');
      setRegisterStatusMessage('Failed to register user');
    }
  };

  const toggleInfoBox = () => {
    setShowInfoBox(prev => !prev);
  };

  const infoMessages = [
    "Must be at least 8 characters long",
    "Must include at least one lowercase letter (a-z)",
    "Must include at least one uppercase letter (A-Z)",
    "Must include at least one number",
    "Must include at least one special character (!@#$%^&*+.?\"={}|_-)",
  ];

  return (
    <>
      <div className="container1">
        <h2>User Registration</h2>
        <br />

        {showRegisterStatus && (
          <div className="row">
            <label className="control-label col-xs-3"></label>
            <span style={{ color: registerStatus === 'success' ? 'green' : 'red' }}>{registerStatusMessage}</span>
          </div>
        )}

        <div className="form-group row">
          <div className="col-xs-4">
            <label><b>Username</b></label>
            <input
              type="text"
              className="form-control input-sm"
              placeholder="Username"
              name="username"
              value={data.username}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {error.usernameNotValid && <span style={{ color: 'red' }}>{error.usernameNotValidText}</span>}

        <br />

        <div className="form-group row align-items-center">
          <label className="col-xs-4">
            <b>Password</b> &nbsp;
            <a onClick={generatePass} className='link'>Generate Password</a>
          </label>
          <div className="col-xs-8 d-flex align-items-center">
            <input
              type={hide ? 'password' : 'text'}
              className="form-control input-sm"
              placeholder="Enter Password"
              name="password"
              value={data.password}
              onChange={handleInputChange}
              style={{ flex: 1 }}
            />
            <img
              className="ms-1"
              src={hide ? '../assets/Group265.svg' : '../assets/Group1567.svg'}
              onClick={() => setHide(!hide)}
              style={{ cursor: 'pointer', width: 20, height: 20 }}
              alt="Toggle Visibility"
            />
            <div
              className="ms-1"
              onMouseEnter={() => setShowInfoBox(true)}
              onMouseLeave={() => setShowInfoBox(false)}
              onClick={toggleInfoBox}
              style={{ position: 'relative', display: 'inline-block' }}
            >
              <img
                src="assets/icons8-info.svg"
                style={{ width: 18, height: 18, cursor: 'pointer' }}
                alt="Info"
              />
              {showInfoBox && (
                <div className="info-box" style={{ position: 'absolute', top: '30px', left: 0, backgroundColor: '#eef', border: '1px solid #ccc', padding: '10px', borderRadius: '8px', zIndex: 10, width: '250px' }}>
                  <strong>Password should:</strong>
                  <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
                    {infoMessages.map((msg, i) => (
                      <li key={i}>{msg}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {error.passwordNotValid && <span style={{ color: 'red' }}>{error.passwordNotValidText}</span>}

        <br />

        <div className="form-group row align-items-start">
          <label className="col-xs-4"><b>Confirm password</b></label>
          <div className="col-xs-8">
            <div className="d-flex align-items-center">
              <input
                type={hide1 ? 'password' : 'text'}
                className="form-control input-sm"
                placeholder="Confirm Password"
                name="confirmpassword"
                value={data.confirmpassword}
                onChange={handleInputChange}
                style={{ flex: 1 }}
              />
              <img
                className="ms-1"
                src={hide1 ? 'assets/Group265.svg' : 'assets/Group1567.svg'}
                onClick={() => setHide1(!hide1)}
                style={{ cursor: 'pointer', width: 20, height: 20 }}
                alt="Toggle Visibility"
              />
              <div
                className="ms-1"
                onMouseEnter={() => setShowInfoBox(true)}
                onMouseLeave={() => setShowInfoBox(false)}
                onClick={toggleInfoBox}
                style={{ position: 'relative', display: 'inline-block', marginLeft: '8px' }}
              >
                <img
                  src="assets/icons8-info.svg"
                  style={{ width: 18, height: 18, cursor: 'pointer' }}
                  alt="Info"
                />
              </div>
            </div>
            {error.confirmpasswordNotValid && (
              <div className="mt-1" style={{ color: 'red', fontSize: 'small' }}>
                {error.confirmpasswordNotValidText}
              </div>
            )}
          </div>
        </div>

        <br />

        <div className="form-group row">
          <div className="col-xs-4">
            <label><b>User type</b></label>
            <select
              className="form-control input-sm"
              name="userType"
              value={data.userType}
              onChange={handleInputChange}
            >
              <option value=""></option>
              {userTypes.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>
        </div>

        {error.usertypeNotValid && <span style={{ color: 'red' }}>{error.usertypeNotValidText}</span>}

        <br />

        <div className="form-group row">
          <div className="col-xs-4">
            <label><b>Workshop name</b></label>
            <select
              className="form-control input-sm"
              name="workshopname"
              value={data.workshopname}
              onChange={handleInputChange}
            >
              <option value=""></option>
              {workshopNames.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>
        </div>

        {error.workshopnameNotValid && <span style={{ color: 'red' }}>{error.workshopnameNotValidText}</span>}

        <br />

        {(data.userType === 'ASC Leader' || data.userType === 'ASC Technician') && (
          <div className="form-group row">
            <div className="col-xs-4">
              <label><b>ASC</b></label>
              <select
                className="form-control input-sm"
                name="site"
                value={data.site}
                onChange={handleInputChange}
              >
                <option value=""></option>
                {sites.map((item) => (
                  <option key={item.site_name} value={item.site_name}>{item.site_name}</option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="form-group row mt-4">
          <div className="col-xs-4">
            <button className="btn btn-primary col-xs-2" onClick={handleRegister}>Register</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default UserRegistration;